import { AddEditCompanyLinkParams, AddEditLinkResult, CompanyLinkData } from "../../../pages/CompanyResources/schema";

import request from "../base-request";

export const getCompanyLinks = async () => {
	const [data] = await request<CompanyLinkData>(`/api/company/links`, {
		method: "GET",
	});
	return data;
};

export const deleteCompanyLink = async (id: string) => {
	const [data] = await request(`/api/remove-company-link/?lid=${id}`, {
		method: "POST",
	});
	return data;
};

export const addEditCompanyLink = async (params: AddEditCompanyLinkParams) => {
	const [data] = await request<AddEditLinkResult>(`/api/add-company-link/`, {
		method: "POST",
		body: JSON.stringify(params),
	});
	return data;
};

export const incrementCompanyLinkScore = async (lid: string) => {
	const [data] = await request(`/api/increment-company-link-score/?lid=${lid}`, {
		method: "POST",
	});
	return data;
};
